export enum UsageSource {
    METER_VAULT = 'METER_VAULT',
    FILE_UPLOAD = 'FILE_UPLOAD'
}